import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "./firebase"; // Make sure db is correctly configured

const counterDocRef = doc(db, "settings", "visitorCounter");

export const getNextVisitorId = async () => {
    const counterDoc = await getDoc(counterDocRef);

    if (counterDoc.exists()) {
        const currentId = counterDoc.data().counter;
        const newId = currentId + 1;

        // Update the counter value
        await updateDoc(counterDocRef, { counter: newId });

        return newId;
    } else {
        // If counter doc doesn't exist, create it and start from 1
        await setDoc(counterDocRef, { counter: 1 }); // Set initial value as 1
        return 1;
    }
};
